export const DURATION = {
  FAST: 0.2,
};
